import React, { memo, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import { getEndpointUrl } from "../../Utils/Common";

const ModalDeleteBrand = ({ onCallback, row, show, close }) => {

    const [isLoading, setLoading] = useState(false);

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    useEffect(() => {

    }, [isLoading, row]);

    const onDelete = () => {
        setLoading(true);

        fetch(getEndpointUrl() + `/v2/car_brand/${row.id}`, {
            method: "DELETE",
            body: new URLSearchParams({
                user_id: userLogin.id
            }),
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status === 'ok') {

                toast.success("Yay, Data merek berhasil dihapus.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });

                onCallback(row);

                close()
            } else {
                toast.error(json.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        }).catch(error => {
            setLoading(false);
        });
    };
    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={show} onHide={close} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Hapus?</Modal.Title>
                </Modal.Header>
                {isLoading ?
                    <Modal.Body>
                        <div className="d-flex justify-content-center mt-5 mb-5">
                            <Loader type="bubble-scale" bgColor={"#E57373"} size={100} />
                        </div>
                    </Modal.Body>
                    :
                    <>
                        <Modal.Body>
                            <p className="mb-0">Yakin anda akan menghapus merek ini?</p>
                            <p className="pt-0 mt-0"><span className="text-danger">{row.companyName}</span></p>
                            <p className="mb-0 text-muted" style={{ fontSize: '12px' }}>Menghapus merek akan menghapus semua model terkait.</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={close}> Batal </Button>
                            <Button variant="danger" onClick={onDelete}>Hapus</Button>
                        </Modal.Footer>
                    </>
                }
            </Modal>
        </>
    );
}

export default memo(ModalDeleteBrand);
